<template>
	<div class="page badge_page">
		<div class="bannerbox">
			<el-carousel indicator-position="none">
			    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
			       <div class="imgbox">
					   <!-- :poster="item.imageUrl" -->
					   <img class="img100" :src="item.imageUrl"/>
					</div>
			    </el-carousel-item>
			</el-carousel>
		</div>
		<div class="badge_conbox badge_rankcon">
			<div class="topbox w1200">
				<div class="itemobj">
					<img class="img100" src="../assets/badge/10.png"/>
				</div>
				<div class="itemobj">
					<img class="img100" src="../assets/badge/11.png"/>
				</div>
				<div class="itemobj">
					<img class="img100" src="../assets/badge/12.png"/>
				</div>
				<div class="itemobj">
					<img class="img100" src="../assets/badge/13.png"/>
				</div>
				<div class="itemobj">
					<img class="img100" src="../assets/badge/14.png"/>
				</div>
			</div>
			
			<div class="wdcj_box w1200">
				<div class="wdcj">
					<img class="icon" src="../assets/badge/wdcj1.png"/>
					<div class="text fontsize24">我的成绩</div>
					<img class="icon" src="../assets/badge/wdcj2.png"/>
				</div>
				<div class="con1">
					<div class="itemobj">
						<div class="text1 fontsize20">{{myrank.honorTitle || "小白"}}</div>
						<div class="text2 fontsize12">等级</div>
					</div>
					<div class="itemobj">
						<div class="text1 fontsize20">{{myrank.totalPoint || "0"}}</div>
						<div class="text2 fontsize12">总分</div>
					</div>
					<div class="itemobj">
						<div class="text1 fontsize20">{{myrank.monthPoint || "0"}}</div>
						<div class="text2 fontsize12">月赛分</div>
					</div>
					<div class="itemobj">
						<div class="text1 fontsize20">{{myrank.questPoint || "0"}}</div>
						<div class="text2 fontsize12">题库分</div>
					</div>
					<div class="itemobj">
						<div class="text1 fontsize20">{{myrank.honorRank || "无"}}</div>
						<div class="text2 fontsize12">当前排名</div>
					</div>
				</div>
				<div class="btn btn1 fontsiz16" @click="handeldzhz">电子徽章</div>
				<div class="btn btn2 fontsiz16" @click="handleshowscore(true)">分数明细</div>
				<div class="btn btn3 fontsiz16" @click="handleshowques(true)">答题统计</div>
			</div>
			
			<div class="rankbox w1200">
				<div class="ranktitle">
					<img class="icon" src="../assets/badge/rank1.png"/>
					<div class="text fontsize36">最强排行榜</div>
					<img class="icon" src="../assets/badge/rank2.png"/>
				</div>
				<div class="ranklist">
					<div class="itemobj fontsize14">
						<div class="text text1">用户</div>
						<div class="text text2">等级</div>
						<div class="text text2">总分</div>
						<div class="text text2">月赛分</div>
						<div class="text text2">题库分</div>
						<div class="text text3">排名</div>
					</div>
					<div class="itemobj itemobj2 fontsize14" v-for="(item,index) in rankList" :key="index">
						<div class="textbox1">
							<img class="icon" :src="item.hlImage || '../assets/logo.png'"/>
							<div class="text clamp">{{item.hlName}}</div>
						</div>
						<div class="text text2">{{item.honorTitle}}</div>
						<div class="text text2">{{item.totalPoint}}</div>
						<div class="text text2">{{item.monthPoint}}</div>
						<div class="text text2">{{item.questPoint}}</div>
						<div class="text text5">
							<img class="icon" src="../assets/badge/rank5.png"/>
							<div class="text">{{item.honorRank}}</div>
							<img class="icon" src="../assets/badge/rank3.png"/>
						</div>
					</div>
				</div>
			</div>
			
			<div class="block58"></div>
		</div>
		<el-dialog
		  title="电子徽章"
		  :visible.sync="dialogVisible"
		  width="30%">
		  <div style="width: 385px;height:360px; margin: 0 auto;">
			  <img v-if="myrank.imgUrl" class="img100" :src="myrank.imgUrl"/>
			  <img v-else class="img100" src="../assets/logo.png"/>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">返 回</el-button>
		  </span>
		</el-dialog>
		<!-- 分数明细 -->
		<div class="score_box_modal" v-if="ifshowscore">
			<div class="conbox">
				<div class="titlebox">
					<img class="icon" src="../assets/badge/rank5.png"/>
					<div class="text fontsize20">分数明细</div>
					<img class="icon" src="../assets/badge/rank3.png"/>
				</div>
				<div class="itemobj fontsize14">
					<div class="text text1">项目</div>
					<div class="text text2">积分</div>
				</div>
				<div class="itemlist">
					<div class="itemobj2 fontsize16" v-for="(item,index) in scoreList" :key="index">
						<div class="text text1">{{item.title}}</div>
						<div class="text text2">{{item.point}}</div>
					</div>
				</div>
				<div class="btn fontsiz16" @click="handleshowscore(false)">关闭</div>
			</div>
		</div>
		<!-- 答题统计 -->
		<div class="score_box_modal" v-if="ifshowques">
			<div class="conbox">
				<div class="titlebox">
					<img class="icon" src="../assets/badge/rank5.png"/>
					<div class="text fontsize20">答题统计</div>
					<img class="icon" src="../assets/badge/rank3.png"/>
				</div>
				<div class="itemobj fontsize14">
					<div class="text text1">等级</div>
					<div class="text text2">数量</div>
				</div>
				<div class="itemlist">
					<div class="itemobj2 fontsize16" v-for="(item,index) in quesscoreList" :key="index">
						<div class="text text1">{{item.title}}</div>
						<div class="text text2">{{item.hlnum}}</div>
					</div>
				</div>
				<div class="btn fontsiz16" @click="handleshowques(false)">关闭</div>
			</div>
		</div>
		
	</div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
	data() {
		return {
			bannerList: [0],
			myrank:{},
			badgeList:[],//荣耀
			rankList:[],
			dialogVisible:false,
			scoreList:[],//积分吗
			ifshowscore:false,//积分
			ifshowques:false,//答题
			quesscoreList:[],//答题情况
		};
	},
	mounted: function() {
		//初始化
		this.initPage()
	},
	computed: {
		...mapState(['userInfo', 'isLogin','sysRole']),
	},
	methods: {
		...mapMutations(["SET_USERINFO",'SET_ISLOGIN']),
		//初始化
		async initPage(){
			//轮播图和广告
			await this.getwheelPage(5)
			//获取榜单
			this.getpointRank()
			this.myPointRank()
			//获取荣誉等
			this.gethonorList()
			//获取积分
			this.getRankscore()
			//获取答题情况
			this.gethonorQuestDetailList()
		},
		//获取答题情况
		gethonorQuestDetailList() {
			var _this = this
			var params = {
				uuid:this.userInfo.uuid
			}
			this.$http.post('app/hlexam/lcUserPoint/honorQuestDetailList', params).then(function(res) {
				//数据处理
				if (res.code == 200) {
					res.data.forEach((item,index)=>{
						item["hlnum"] = item.hlHonorQuestDetail.monthQuestNum + item.hlHonorQuestDetail.questNum
					})
					_this.quesscoreList = res.data
				} else {
					_this.$confirm(res.message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {});
				}
			})
		},
		//积分详情
		handleshowscore(type){
			this.ifshowscore = type
		},
		//答题统计
		handleshowques(type){
			this.ifshowques = type
		},
		//电子徽章
		handeldzhz(){
			const obj = this.badgeList.find((ifitem) => { //这里的options就是上面遍历的数据源
				return ifitem.id == this.myrank.honorId; //筛选出匹配数据
			});
			if(obj){
				this.myrank["imgUrl"] = obj.imgUrl
			}else{
				this.myrank["imgUrl"] = ""
			}
			this.dialogVisible = true
		},
		//获取积分
		getRankscore() {
			var _this = this
			var params = {
				userUuid:this.userInfo.uuid
			}
			params["currentPage"] = 1
			params["pageSize"] = 9999
			this.$http.post('app/hlexam/lcUserPoint/index', params).then(function(res) {
				//数据处理
				if (res.code == 200) {
					_this.scoreList = res.data.records
				} else {
					_this.$confirm(res.message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {});
				}
			})
		},
		//获取榜单
		getpointRank() {
			var _this = this
			var params = {}
			params["currentPage"] = 1
			params["pageSize"] = 20
			this.$http.post('app/hlexam/lcUserPoint/pointRank', params).then(function(res) {
				//数据处理
				if (res.code == 200) {
					_this.rankList = res.data.records
				} else {
					_this.$confirm(res.message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {});
				}
			})
		},
		//获取榜单
		myPointRank() {
			var _this = this
			var params = {
				userUuid:this.userInfo.uuid
			}
			this.$http.post('app/hlexam/lcUserPoint/myPointRank', params).then(function(res) {
				//数据处理
				if (res.code == 200) {
					_this.myrank = res.data
				} else {
					_this.$confirm(res.message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {});
				}
			})
		},
		//获取荣誉等
		gethonorList() {
			var _this = this
			var params = {}
			params["currentPage"] = 1
			params["pageSize"] = 18
			this.$http.post('app/hlexam/lcUserPoint/honorList', params).then(function(res) {
				//数据处理
				if (res.code == 200) {
					_this.badgeList = res.data
				} else {
					_this.$confirm(res.message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {});
				}
			})
		},
		//获取轮播图
		getwheelPage(type) {
			var _this = this
			return new Promise((resolve, reject) => {
				var params = {}
				params["currentPage"] = 1
				params["pageSize"] = 18
				params["type"] = type
				this.$http.post('app/wheel-advert/getPage', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						var records = res.data.records
						// imageUrl:require("../assets/static/banner1.png")
						if(records.length>0){
							_this.bannerList = records
						}
						resolve(true)
					} else {
						reject(false)
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			})
		},
		//跳转
		navigato(url,query) {
			this.$util.routerPath(url,query)
		},
		
	}
};
</script>
<style lang="scss" scoped>
	.hoverbig:hover{
	    transform: scale(1.05);
	    transition: ease all 0.3s;
	}
	
</style>
